// hooks/preloader.hook.ts
import { useState, useEffect } from 'react';

export const usePreloader = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(false); // immediately hide preloader on mount
  }, []);

  return loading;
};
